// E-Mail → Brief (E-POST): Empfänger zur Mail-Adresse finden, Anhänge (Bucket email-anhaenge) als Briefanlagen.
import { supabase } from '../supabase/client';
import type { EmpfaengerTreffer } from '../dokumente/briefApi';

const nameVon = (x: { vorname?: string | null; nachname?: string | null; firma_name?: string | null }) =>
  [x.vorname, x.nachname].filter(Boolean).join(' ').trim() || (x.firma_name ?? '').trim() || 'Ohne Namen';

/** Mieter/Eigentümer/Kontakt zur E-Mail-Adresse (erst kontakt_kanaele, dann E-Mail-Spalten) – sonst null. */
export async function findeEmpfaengerZuEmail(email: string): Promise<EmpfaengerTreffer | null> {
  const adr = email.trim();
  if (!adr) return null;
  const { data: kanal } = await supabase.from('kontakt_kanaele').select('owner_type, owner_id')
    .eq('kanal', 'email').ilike('wert', adr).order('ist_primaer', { ascending: false }).limit(1).maybeSingle();
  const art = kanal?.owner_type as string | undefined;
  if (kanal && (art === 'mieter' || art === 'eigentuemer' || art === 'kontakt')) {
    const tabelle = art === 'kontakt' ? 'kontakte' : art;
    const { data } = await supabase.from(tabelle).select('id, vorname, nachname, firma_name').eq('id', kanal.owner_id).maybeSingle();
    if (data) return { art, id: data.id, name: nameVon(data), sub: '' };
  }
  for (const [tabelle, a] of [['mieter', 'mieter'], ['eigentuemer', 'eigentuemer'], ['kontakte', 'kontakt']] as const) {
    const { data } = await supabase.from(tabelle).select('id, vorname, nachname, firma_name').ilike('email', adr).limit(1).maybeSingle();
    if (data) return { art: a, id: data.id, name: nameVon(data), sub: '' };
  }
  return null;
}

/** MIME-Typ aus dem Dateinamen (Anhänge im Storage tragen keinen). */
export function mimeAusName(name: string): string {
  const e = name.toLowerCase().split('.').pop() ?? '';
  return e === 'pdf' ? 'application/pdf' : e === 'png' ? 'image/png' : e === 'jpg' || e === 'jpeg' ? 'image/jpeg' : 'application/octet-stream';
}

/** Anhang aus dem Bucket email-anhaenge laden. */
export async function ladeMailAnhang(path: string): Promise<Blob> {
  const { data, error } = await supabase.storage.from('email-anhaenge').download(path);
  if (error || !data) throw new Error(`Anhang nicht ladbar: ${error?.message ?? path}`);
  return data;
}
